import store from "src/store";

export function setCardColor() {
  const obj = store.getters['params/clients'].find((obj) => obj.id === store.getters['common/id_user_client_selected'])
  let colors = [];
  if(obj.use_filter_cards_variant_color === true) {
    const primary = obj.set_filter_cards_color !== '#000000' ? obj.set_filter_cards_color.replace(/^#/, '') : obj.colors.primary.replace(/^#/, '')
    for (let i = 1; i <= 8; i++) {
      const factor = 1 - (0.1 * i);
      const adjustedFactor = 1 - Math.pow((1 - factor), 2);
      const adjustedR = Math.round(parseInt(primary.substring(0, 2), 16) * adjustedFactor).toString(16).padStart(2, '0');
      const adjustedG = Math.round(parseInt(primary.substring(2, 4), 16) * adjustedFactor).toString(16).padStart(2, '0');
      const adjustedB = Math.round(parseInt(primary.substring(4, 6), 16) * adjustedFactor).toString(16).padStart(2, '0');
      colors.push(`#${adjustedR.toString(16)}${adjustedG.toString(16)}${adjustedB.toString(16)}`);
    }
    return {
      '--bg-primary-color': colors[6],
      '--bg-secondary-color': colors[5],
      '--bg-tertiary-color': colors[3],
      '--bg-quaternary-color': colors[1],
    }
  }
  const primary = obj.set_filter_cards_color !== '#000000' ? obj.set_filter_cards_color : obj.colors.primary
  return {
    '--bg-primary-color': primary,
    '--bg-secondary-color': primary,
    '--bg-tertiary-color': primary,
    '--bg-quaternary-color': primary,
  }
}

export default { setCardColor }